export const FLOW_TEST_REQUEST_STATUS = {
  triggered: 'triggered' as const,
  triggerFailure: 'triggerFailure' as const,
  triggerSuccess: 'triggerSuccess' as const,
  inProgress: 'inProgress' as const,
  resultDone: 'resultDone' as const,
  resultTimeOut: 'resultTimeOut' as const,
} as const;

export const FlowTestStates = {
  idle: 'idle' as const,
  inProgress: 'inProgress' as const,
  error: 'error' as const,
  success: 'success' as const,
} as const;

export type FlowTestRequestStatus = keyof typeof FLOW_TEST_REQUEST_STATUS;

/** Union of the different shapes of the testing state
 * our Flow test can be in, for Flux
 */
export type FlowTestingStateTypes =
  | {
      requestStatus:
        | typeof FLOW_TEST_REQUEST_STATUS.triggered
        | typeof FLOW_TEST_REQUEST_STATUS.triggerFailure;
    }
  | {
      requestStatus:
        | typeof FLOW_TEST_REQUEST_STATUS.triggerSuccess
        | typeof FLOW_TEST_REQUEST_STATUS.inProgress
        | typeof FLOW_TEST_REQUEST_STATUS.resultTimeOut;
      eventId: string;
    }
  | {
      requestStatus: typeof FLOW_TEST_REQUEST_STATUS.resultDone;
      eventId: string;
      result: {
        id: string;
        flowId: string;
        timeline: string;
        result: string;
      };
    };
